const THROTTLING_INTERVAL = {
  DAY: 'day',
  MONTH: 'month'
}

export default [

  {
    id: 1,
    active: true,
    name: 'Встраивание ТНВЭД на сайт',
    api: false,
    type: 'tnved',
    throttling: 100,
    throttling_interval: THROTTLING_INTERVAL.DAY,
    price_per_month: 1,
    price_per_year: 10
  },

  {
    id: 2,
    active: true,
    name: 'Встраивание ЕТСНГ на сайт',
    api: false,
    type: 'etsng',
    throttling: 100,
    throttling_interval: THROTTLING_INTERVAL.DAY,
    price_per_month: 1,
    price_per_year: 10
  },

  {
    id: 3,
    active: false,
    name: 'Встраивание ГНГ на сайт',
    api: false,
    type: 'gng',
    throttling: 100,
    throttling_interval: THROTTLING_INTERVAL.DAY,
    price_per_month: 1,
    price_per_year: 10
  },

  {
    id: 4,
    active: true,
    name: 'Доступ к данным для расчета. 10 расчетов в день',
    api: true,
    throttling: 10,
    throttling_interval: THROTTLING_INTERVAL.DAY,
    price_per_month: 10,
    price_per_year: 100
  },

  {
    id: 5,
    active: true,
    name: 'Доступ к данным для расчета. 100 расчетов в день',
    api: true,
    throttling: 100,
    throttling_interval: THROTTLING_INTERVAL.DAY,
    price_per_month: 100,
    price_per_year: 1000
  }

]



// WEBPACK FOOTER //
// ./src/server/fixtures/service-type.js